import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IUpdatePersonalDetails } from 'Interfaces/updatePersonalDetails';
import { useAppSelector } from './useAppSelector';
import { getFamilyMembersSchema } from 'Modules/Requests/UpdatePersonalDetails/Schema';
import { useEffect, useState } from 'react';

export const useFamilyMembersForm = () => {
  const [isDirty, setIsDirty] = useState(false);

  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const familyMembersForm = useForm<{
    familyMembers: IUpdatePersonalDetails['familyMembers'];
  }>({
    mode: 'all',
    resolver: yupResolver(getFamilyMembersSchema(isDirty)),
    defaultValues: {
      familyMembers: [
        {
          gender: generalOptions?.general?.genders?.[0]?.id || 0,
          birthDate: null,
        },
      ],
    },
  });

  useEffect(() => {
    setIsDirty(familyMembersForm.formState.isDirty);
  }, [familyMembersForm.formState.isDirty]);

  return familyMembersForm;
};
